import React from 'react';
import { ErrorsContext } from './ErrorsContext';

export const useErrorsContext = () => {
  const context = React.useContext(ErrorsContext);

  if (!context) {
    throw new Error('This component should be wrapped by ErrorsContextProvider');
  }

  return context;
};
